<meta name="viewport" content="width=device-width, initial-scale=1.0">
</meta>
<template>
  <div class="block backDark">
    <v-container>
      <h2 class="text-center">News</h2>
      <h1 class="titleSection">{{ lastNews.title }}</h1>
      <v-row :item="lastNews">
        <v-img class="imgNewsSection" :src="lastNews.images[0] ? '/repo/wot-lab/img/' + lastNews.images[0] : '/repo/wot-lab/img/no_image.jpg'" />
        <div class="announceText">
          <p class="text--primary">{{ lastNews.announce }}</p>
          <div class="dataText">
            <p style="margin-right: 2rem">{{ lastNews.author }}</p>
            <p>{{ formatDate(lastNews.fecha, lastNews?.hora) }}</p>
          </div>
          <router-link style="color:white" :to="{ name: 'news-section', params: { id: lastNews.id } }">
            <v-btn class="hover" color="#f05a49" elevation="0" dark>Read more</v-btn>
          </router-link>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//import newsAPI from "../../services/newsAPI";
import newsData from "@/assets/json/news.json";

export default {
  name: "NewsSection",
  data() {
    return {
      items: []
    };
  },
  computed: {
    lastNews() {
      if (this.items.length === 0) return {};
      return this.items
        .slice()
        .sort((a, b) => {
          const dateA = this.parseDate(a.fecha, a.hora || "00:00");
          const dateB = this.parseDate(b.fecha, b.hora || "00:00");
          return dateB - dateA;
        })[0];
    },
    moreRedirect(id) {
      this.$router.push({ name: 'news-section', params: { id: id } });
      this.$router.go(0);
    }
  },
  created() {
    this.getNews();
  },
  methods: {
    /** 
    getNews() {
      newsAPI.get("/posts").then((response) => {
        this.items = response.data;
      });
    },
    */
    getNews() {
      this.items = newsData.sort((a, b) => {
        const dateA = this.parseDate(a.fecha, a.hora || "00:00");
        const dateB = this.parseDate(b.fecha, b.hora || "00:00");
        return dateB - dateA;
      });
    },
    parseDate(dateInput, timeInput = "00:00") {
      if (!dateInput || typeof dateInput !== 'string') return null;

      const dateRegex = /^(?:(\d{2})\/(\d{2})\/(\d{2,4})|(\d{2})-(\d{2})-(\d{2,4}))$/;
      const match = dateInput.match(dateRegex);
      if (!match) return null;

      let day, month, year;

      if (match[1] && match[2] && match[3]) {
        // dd/mm/yy o dd/mm/yyyy
        day = match[1];
        month = match[2];
        year = match[3];
      } else if (match[4] && match[5] && match[6]) {
        // mm/dd/yy o mm/dd/yyyy
        month = match[4];
        day = match[5];
        year = match[6];
      } else {
        return null;
      }

      // Convertir años de 2 dígitos a 4 dígitos (suponiendo 2000-2099)
      if (year.length === 2) {
        year = year < 50 ? `20${year}` : `19${year}`;
      }

      // Crear la fecha en formato ISO (yyyy-mm-dd)
      const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

      // Ahora agregamos la hora, si está definida
      const fullDate = `${isoDate}T${timeInput}:00`;

      // Retornar la fecha completa con la hora agregada
      return new Date(fullDate);
    },

    /**
     * Función para formatear la fecha y hora
     */
    formatDate(dateString, timeString) {
      const date = this.parseDate(dateString, timeString);
      if (!date || isNaN(date)) return "Invalid Date";
      const options = { 
        year: "numeric", 
        month: "2-digit", 
        day: "2-digit", 
        hour: "2-digit", 
        minute: "2-digit", 
        timeZone: "Europe/Paris" 
      };
      return new Intl.DateTimeFormat("en-GB", options).format(date);
    }

  },
};
</script>

<style>
.backDark {
  background: #b0b5bf;
}

.titleSection {
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
}

.imgNewsSection {
  width: 400px; /* Ajusta el ancho según tus necesidades */
  height: 300px; /* Ajusta la altura según tus necesidades */
  object-fit: cover; /* Asegura que la imagen llene el contenedor */
}

.announceText {
  width: 50%;
  font-size: 20px;
  text-align: center;
  align-self: center;
  padding: 1rem;
}

.dataText {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 0.9rem;
}
.hover {
  transition: cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.2s;
}
.hover:hover {
  background-color: transparent !important;
  border: #f05a49 1px solid!important;
  color: #f05a49 !important;
  transition: cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.2s;
}

@media (max-width: 960px) {
  .announceText {
    width: 100%;
  }
}
</style>